import * as React from "react";

import "./Icon.css";

const SvgDeleteIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 60 60"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon  ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <defs>
      <style>{".Delete_Icon_svg_cls-1{fill:currentColor}"}</style>
    </defs>
    <g transform="translate(12,6)">
      <path
        id="Delete_Icon_svg_Body"
        d="m0 11 5 37h25.88l5-37Zm8.46 28.27L4.73 16.65h4.85l1.24 22.62Zm11.27 0h-3.61V16.65h3.61Zm7.59 0H25l1.2-22.62H31Z"
        className="Delete_Icon_svg_cls-1"
      />
      <path
        id="Delete_Icon_svg_Lid"
        d="M33.37 2.9h-9.51L22.61 0h-9.37L12 2.9H2.49L0 9.43h35.85z"
        className="Delete_Icon_svg_cls-1 lid"
      />
    </g>
  </svg>
);
export default SvgDeleteIcon;
